<script setup>
</script>

<template>
  <footer id="contacto">
    <div class="footer-container">
      <div class="footer-brand">
        <h3>Digital Power</h3>
        <p>Potenciando tu presencia digital con soluciones a medida que transforman tu negocio.</p>
        <div class="social-links">
          <a href="https://instagram.com/digitalpower_ok" target="_blank" class="social-icon">
            <i class='bx bxl-instagram'></i>
          </a>
          <a href="https://wa.me/541123965757" target="_blank" class="social-icon">
            <i class='bx bxl-whatsapp'></i>
          </a>
        </div>
      </div>

      <div class="footer-links">
        <div class="link-group">
          <h4>Navegación</h4>
          <a href="#hero">Inicio</a>
          <a href="#servicios">Servicios</a>
          <a href="#planes">Planes</a>
          <a href="#clientes">Proyectos</a>
        </div>
        <div class="link-group">
          <h4>Contacto</h4>
          <a href="mailto:info@digitalpower.ar"><i class='bx bx-envelope'></i> info@digitalpower.ar</a>
          <a href="https://wa.me/541123965757"><i class='bx bx-phone'></i> +54 11 2396-5757</a>
          <p><i class='bx bx-map'></i> Buenos Aires, Argentina</p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>&copy; {{ new Date().getFullYear() }} Digital Power Development. Todos los derechos reservados.</p>
    </div>
  </footer>
</template>

<style scoped lang="scss">
#contacto {
  width: 100%;
  background: #0f172a; // Dark text-main color
  color: #e2e8f0;
  padding: 5rem 2rem 2rem 2rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 4rem;
  padding-bottom: 4rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  flex-wrap: wrap;
}

.footer-brand {
  max-width: 350px;

  h3 {
    color: white;
    font-size: 1.8rem;
    margin-bottom: 1rem !important;
    background: linear-gradient(135deg, white, var(--text-muted));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    color: var(--text-muted);
    line-height: 1.6;
    margin-bottom: 2rem !important;
  }
}

.social-links {
  display: flex;
  gap: 1rem;

  .social-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: rgba(255,255,255,0.05);
    border-radius: 50%;
    color: white;
    text-decoration: none;
    font-size: 1.2rem;
    transition: all var(--duration);

    &:hover {
      background: var(--primary);
      transform: translateY(-3px);
    }
  }
}

.footer-links {
  display: flex;
  gap: 4rem;
  flex-wrap: wrap;
}

.link-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h4 {
    color: white;
    font-size: 1.1rem;
    margin-bottom: 0.5rem !important;
  }

  a, p {
    color: var(--text-muted);
    text-decoration: none;
    transition: color var(--duration);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.95rem;

    i {
      font-size: 1.2rem;
    }
  }

  a:hover {
    color: white;
  }
}

.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 2rem;
  text-align: center;

  p {
    color: var(--text-muted);
    font-size: 0.9rem;
  }
}

@media screen and (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    gap: 3rem;
  }
}
</style>